// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"214":"views-error","701":"views-user","957":"views-app"}[chunkId] || chunkId) + "." + {"214":"b0081f6b","453":"94aea463","701":"806677ea","957":"4da2add0"}[chunkId] + ".chunk.js";
};